import React, { useRef, useState } from "react";
import { colors, fonts, mediaQueriesNumbers, useMediaQuery, frames, glyphs, css } from "../../Styles";
import { NewInputList, NewModal, MainContentPaddingTypes } from "..";
import { ButtonTypes, ListStyle_Types, NewInputListHandles } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { useUser } from "../../Services"
import NewButton from "../BaseComponents/Buttons/newButton";

interface createUserProps {
  ifSuccess: () => void
  onGoBack: () => void
}

export default function CreateUserModal({ifSuccess, onGoBack}:createUserProps) {
  const {t} = useTranslation()
  const { createNewUser } = useUser()
  const inputRefOne=useRef<NewInputListHandles>(null)
  const inputRefTwo=useRef<NewInputListHandles>(null)
  const [message, setMessage] = useState<string|null>(null)
  const mobile = useMediaQuery(`(max-width: ${mediaQueriesNumbers.mobileMax}px)`);  

  // Use "Enter" to submit
  onkeydown = (event) => {
    if (event.code === "Enter") {
      handleCreateUserBtn()
    }
  }

  const handleCreateUserBtn = () => {if (inputRefOne && inputRefOne.current && inputRefTwo && inputRefTwo.current) {
    const refsOne = inputRefOne.current.refs?.current;
    const refsTwo = inputRefTwo.current.refs?.current;

    if (refsOne && refsTwo) {
      var Username = inputRefOne.current.refs.current[0].value
      var Password = inputRefOne.current.refs.current[1].value
      var RepeatPassword = inputRefOne.current.refs.current[2].value
      var FirstName = inputRefTwo.current.refs.current[0].value
      var LastName = inputRefTwo.current.refs.current[1].value
      var Email = inputRefTwo.current.refs.current[2].value
      var Phone = inputRefTwo.current.refs.current[3].value

      if(!Username) {
        inputRefOne.current.refs.current[0].setError()
        setMessage(t("loginFlow.createUser.missingUserName", {defaultValue: "User name is missing"}));
      }
      else if (!Password ) {
        inputRefOne.current.refs.current[1].setError()
        setMessage(t("loginFlow.createUser.missingPassword", {defaultValue: "Password is missing"}));
      }
      else if (!RepeatPassword) {
        inputRefOne.current.refs.current[2].setError()
        setMessage(t("loginFlow.createUser.missingRepeatPassword", {defaultValue: "Please repeat password"}));
      }
      else if (RepeatPassword !== Password) {
        inputRefOne.current.refs.current[2].setError()
        setMessage(t("loginFlow.createUser.passwordMismatch", {defaultValue: "Password Mismatch"}));
      }
      else {
        createNewUser(Username.toString(), Password.toString(), FirstName.toString(), LastName.toString(), Email.toString(), Phone.toString())
          .then((responseSuccess) => {
            if (responseSuccess) {
              setMessage(t("loginFlow.createUser.success", {defaultValue: "Success"}));
              ifSuccess()
            } else {
              setMessage(t("loginFlow.createUser.fail", {defaultValue: "Failed to create user"}));
            }
          } )
      }
      setTimeout(() => {
        setMessage(null);
      }, 2000);
    }
  }}

  return (
    <frames.DecorBg>
      <NewModal
        modalState
        header={t("loginFlow.createUser.newUser", {defaultValue: "New User"})}
        predefinedButtons={{
          onGoBack: onGoBack
        }}
        overrides={{ 
          mainContentPadding: MainContentPaddingTypes.secondary,
          overlayColor: colors.blackPrimary+"99"
        }}
        mainContent={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "start", justifyContent: "center", gap: "40px"}}>
              <NewInputList ref={inputRefOne}
                headers={[t("required", {defaultValue: "required"}), "", ""]}
                isRequired={[true, true, true]}
                startEnhancers={[glyphs.User({size: "25px"}), glyphs.Password({size: "25px"}), glyphs.Password({size: "25px"})]}
                placeholders={[t("user.userName", {defaultValue: "user name"}), t("user.password", {defaultValue: "password"}), t("user.repeatPassword", {defaultValue: "repeat password"})]}
                valueOverrides={{
                  valueTypes: ["text", "password", "password"]
                }}
                listOverrides={{
                  listGap: "10px",
                  listStyle: ListStyle_Types.vertical
                }}
              />
              <NewInputList ref={inputRefTwo}
                headers={[t("optional", {defaultValue: "optional"}), "", "", ""]}
                startEnhancers={[glyphs.User({size: "25px"}), glyphs.User({size: "25px"}), glyphs.Mail({size: "25px"}), glyphs.Phone({size: "25px"})]}
                placeholders={[t("user.firstName", {defaultValue: "first name"}), t("user.lastName", {defaultValue: "last name"}), t("user.email", {defaultValue: "email"}), t("user.phone", {defaultValue: "phone"})]}
                valueOverrides={{
                  valueTypes: ["text", "text", "email", "tel"]
                }}
                listOverrides={{
                  listGap: "10px",
                  listStyle: ListStyle_Types.vertical
                }}
              />
            </div>
            {/* Create User Button */}
            <NewButton content={t("buttons.create", {defaultValue: "create"})} onClick={handleCreateUserBtn}
              buttonType={ButtonTypes.primaryButton}
            />
            {message && <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, position: "absolute", top: mobile ? "520px" : "375px" }}>{message}</p>}
          </div>
        }
      />
    </frames.DecorBg>   
  )
}